import {FormEvent,useEffect,useState} from 'react';
import {api,BulkCapacityStatus} from '../lib/api';
import {canApplyBulkCapacity} from '../lib/bulkCapacity.js';

export function BulkCapacity(){
  const [status,setStatus]=useState<BulkCapacityStatus>();
  const [draft,setDraft]=useState('');
  const [busy,setBusy]=useState(false);
  const [error,setError]=useState('');
  const [message,setMessage]=useState('');
  async function refresh(reset=false){
    setBusy(true);setError('');
    try{
      const next=await api.bulkCapacity();setStatus(next);
      setDraft(old=>reset||old===''?String(next.capacity??''):old);
    }catch(err){setStatus(undefined);setError((err as Error).message)}
    finally{setBusy(false)}
  }
  useEffect(()=>{void refresh(true)},[]);
  async function apply(event:FormEvent){
    event.preventDefault();
    const value=Number(draft);
    if(busy||!canApplyBulkCapacity(status,value))return;
    if(!confirm(`ظرفیت Bulk به ${value} تغییر کند؟ این ظرفیت بین رونویسی و ترجمه مشترک است.`))return;
    setBusy(true);setError('');setMessage('');
    try{
      const result=await api.saveBulkCapacity(value);setMessage(result.message);
      const next=await api.bulkCapacity();setStatus(next);setDraft(String(next.capacity??value));
    }catch(err){setStatus(undefined);setError((err as Error).message)}
    finally{setBusy(false)}
  }
  return <section className="card promptSettings bulkCapacitySettings">
    <div><p className="eyebrow">BULK WORKER CAPACITY</p><h2>ظرفیت پردازش پوشه‌ها</h2>
      <p className="muted">تعداد Jobهای هم‌زمانِ Bulk؛ مشترک بین رونویسی و ترجمه. این عدد اندازهٔ بستهٔ ترجمه یا تعداد کلید API نیست.</p></div>
    <div className="formActions"><button className="secondary" type="button" disabled={busy} onClick={()=>void refresh()}>{busy?'در حال بررسی…':'به‌روزرسانی وضعیت'}</button></div>
    {error&&<div className="error">{error}</div>}
    {message&&<div className="success">{message}</div>}
    {status&&<>
      <p>ظرفیت فعلی Bulk: <b>{status.capacity??'نامشخص'}</b> · مقدار ذخیره‌شده: <b>{status.saved_capacity??'تنظیم اولیهٔ سرور'}</b></p>
      <p className="muted">Interactive و Scanner تغییر نمی‌کنند. افزایش ورکر لزوماً سرعت را بیشتر نمی‌کند و ممکن است فشار دیسک و API را افزایش دهد.</p>
      {!status.can_apply&&<div className="info">تغییر فعلاً مجاز نیست: همهٔ پردازش‌ها باید متوقف و هر سه سرویس پاسخ‌گو باشند. پس از پایان توقف، وضعیت را به‌روزرسانی کنید.</div>}
      <form onSubmit={apply}>
        <label>تعداد ورکر Bulk (۱ تا {status.maximum})<input dir="ltr" type="number" min="1" max={status.maximum} step="1" required value={draft} disabled={busy} onChange={e=>setDraft(e.target.value)}/></label>
        <button className="primary" disabled={busy||!canApplyBulkCapacity(status,Number(draft))}>اعمال و ذخیرهٔ ظرفیت</button>
      </form>
      <div className="tableWrap"><table><thead><tr><th>سرویس</th><th>فعال</th><th>رزروشده</th><th>زمان‌بندی‌شده</th></tr></thead><tbody>{status.nodes.map(node=><tr key={node.name}><td>{node.role}</td><td>{node.active}</td><td>{node.reserved}</td><td>{node.scheduled}</td></tr>)}</tbody></table></div>
    </>}
  </section>
}
